export enum ChartType {
    PIE = 'PIE',
    LINE = 'LINE',
    RADIAL = 'RADIAL',
    PERCENT = 'PERCENT',
    AREA = 'AREA',
}

export interface ChartData {
    count: number; // answer count
    transition: number; // visit count
    effect: number; // efficiency
    break: number; // disqual count
    average: number; // average response time
}

export interface Legend {
    name: string;
    percent: number;
    count: number;
}

export interface Chart {
    type: ChartType;
    name: string;
    legends: Array<Legend>;
}

export const initialChartData: Readonly<ChartData> = {
    count: 0,
    transition: 0,
    effect: 0,
    break: 0,
    average: 0,
};

export const mapChartStat = ({
    DISQUAL_COUNT,
    EFFICIENCY_AVERAGE,
    QUERY_COUNT,
    RESPONSE_COUNT,
    TIME_AVERAGE,
}: any): ChartData => ({
    count: Number(QUERY_COUNT),
    transition: Number(RESPONSE_COUNT),
    effect: EFFICIENCY_AVERAGE,
    break: Number(DISQUAL_COUNT),
    average: parseInt(TIME_AVERAGE),
});

export const mapChartDate = ({ CNT, START_DATE }: { CNT: number; START_DATE: string }): Legend => ({
    name: START_DATE,
    percent: 0,
    count: CNT,
});

export const mapChartOs = ({ CNT, OS }: { CNT: number; OS: string }): Legend => ({
    name: OS,
    percent: 0,
    count: CNT,
});

export const mapChartBrowser = ({ BROWSER, CNT }: { BROWSER: string; CNT: number }): Legend => ({
    name: BROWSER,
    percent: 0,
    count: CNT,
});

export const mapChartDevice = ({ CNT, DEVICE }: { CNT: number; DEVICE: string }): Legend => ({
    name: DEVICE,
    percent: 0,
    count: CNT,
});

type SurveySource = 'direct' | 'embed' | 'widget' | 'popup' | 'enjoypanel';

const mapSourceName = (source: SurveySource): string =>
    ({
        direct: 'Прямая ссылка',
        embed: 'Встраивание',
        widget: 'Виджет',
        popup: 'Попап',
        enjoypanel: 'Панель респондентов',
    }[source] || source);

export const mapChartUri = ({ CNT, SOURCE }: { CNT: number; SOURCE: SurveySource }): Legend => ({
    name: mapSourceName(SOURCE),
    percent: 0,
    count: CNT,
});
